import script from "./ReviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ReviewPage.vue?vue&type=script&setup=true&lang=js"

import "./ReviewPage.vue?vue&type=style&index=0&id=c9c71be8&lang=scss"

const __exports__ = script;

export default __exports__